import React, { useState, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import useBreakpoint from "use-breakpoint";
import { Drawer, Layout, Menu } from 'antd';
import navigationConfig from 'config/NavigationConfig';
import { useStore } from '../../Views/App-Views/RIC/webparts/ric/stores/root-store-context';
import { observer } from 'mobx-react-lite';
import UserData from '../../utils/UserData';
import logo from "../../assests/images/logo_light.jpg";

const { Sider } = Layout;

const Sidebars = observer(() => {
  const { applicationStore } = useStore();
 // const role = UserData()?.getRoles();
  const [openKeys, setOpenKeys] = useState([]);
  const { breakpoint } = useBreakpoint({ mobile: 0, desktop: 750 });
  const location = useLocation();
  const userRoutes = navigationConfig?.userRoles["admin"] || [];

  const findKey = (routes, matcher) => {
    for (const item of routes) {
      if (item.path && matcher(item.path)) return item.key;
      if (item.children) {
        const childKey = findKey(item.children, matcher);
        if (childKey) return childKey;
      }
    }
    return null;
  };

  const selectedKey = useMemo(() => {
    const pathname = location.pathname;
    return (
      findKey(userRoutes, (path) => path === pathname) ||
      findKey(userRoutes, (path) => pathname.startsWith(`${path}/`))
    );
  }, [userRoutes, location.pathname]);

  const handleOpenChange = (keys) => {
    setOpenKeys(keys);
  };
  
  const filterNavByAccess = (routes, accessPages) => {
    if (!accessPages || !Array.isArray(accessPages)) return routes;
    
    return routes.filter(route => {
      const hasDirectAccess = accessPages?.includes(route?.key);
      
      if (route?.children) {
        route.children = filterNavByAccess(route.children, accessPages);
        // Show parent menu if it has accessible children OR direct access
        return hasDirectAccess || route.children.length > 0;
      }
      
      return hasDirectAccess;
    });
  };
  
  const accessPages = UserData()?.getAccessPages?.() || []; 
  const filteredRoutes = filterNavByAccess(userRoutes, accessPages);
  
  const buildMenuItems = (items) => {
    return items.map((item) => {
      if (item.children) {
        return {
          key: item.key,
          icon: item.icon,
          label: item.label,
          children: buildMenuItems(item.children),
        };
      }
      
      return {
        key: item.key,
        icon: item.icon,
        label: <Link to={item.path}>{item.label}</Link>,
      };
    });
  };

  const menuItems = buildMenuItems(filteredRoutes);
  
  if (breakpoint === "mobile") {
    return (
      <Drawer
        placement="left"
        open={applicationStore?.isCollapsed}
        onClose={() => applicationStore?.setIsCollapsed(false)}
        width={280}
        styles={{ body: { padding: 0 } }}
      >
        <div style={{ padding: '16px', textAlign: 'center' }}>
          <Link to="/">
            <img src={logo} alt="Logo" style={{ maxWidth: '50%', height: 'auto' }} />
          </Link>
        </div>
        <Menu
          theme="light"
          mode="inline"
          selectedKeys={selectedKey ? [selectedKey] : []}
          openKeys={openKeys}
          onOpenChange={handleOpenChange}
          items={menuItems}
          onClick={() => applicationStore?.setIsCollapsed(false)}
        />
      </Drawer>
    );
  }

  const isSidebarCollapsed = applicationStore?.isCollapsed;

  return (
    <Sider
      trigger={null}
      theme="light"
      width="300px"
      collapsedWidth={90}
      breakpoint="lg"
      collapsible
      collapsed={isSidebarCollapsed}
      onCollapse={(collapsed) => {
        applicationStore?.setIsCollapsed(collapsed);
      }}
      className="app-sidebar"
    >
      <div className="logo-container">
        <div style={{ padding: '16px', textAlign: 'center' }}>
          <Link to="/">
            <img src={logo} alt="Logo" style={{ maxWidth: isSidebarCollapsed ? "106%" : "50%", height: "auto" }} />
          </Link>
        </div>
      </div>
      <Menu
        theme="light"
        mode="inline"
        selectedKeys={selectedKey ? [selectedKey] : []}
        openKeys={openKeys}
        onOpenChange={handleOpenChange}
        items={menuItems}
      />
    </Sider>
  );
});

export default Sidebars;